import { DropdownMenu as Primitive } from 'radix-ui';
import { cn } from '../lib/cn';

export const Dropdown = Primitive.Root;
export const DropdownTrigger = Primitive.Trigger;

export function DropdownContent({
  className,
  sideOffset = 6,
  align = 'start',
  ...props
}: React.ComponentProps<typeof Primitive.Content>) {
  return (
    <Primitive.Portal>
      <Primitive.Content
        sideOffset={sideOffset}
        align={align}
        className={cn(
          'z-50 min-w-[200px] rounded-wc-lg border border-subtle bg-raised p-1 shadow-wc-lg',
          className,
        )}
        {...props}
      />
    </Primitive.Portal>
  );
}

export function DropdownItem({
  className,
  danger = false,
  ...props
}: React.ComponentProps<typeof Primitive.Item> & { danger?: boolean }) {
  return (
    <Primitive.Item
      className={cn(
        'flex cursor-pointer items-center gap-2 rounded-wc-sm px-2.5 py-2 toque:min-h-10 text-[13px] font-medium outline-none select-none',
        'data-[highlighted]:bg-hover data-[disabled]:pointer-events-none data-[disabled]:opacity-50',
        danger ? 'text-error' : 'text-primary',
        className,
      )}
      {...props}
    />
  );
}

export function DropdownLabel({
  className,
  ...props
}: React.ComponentProps<typeof Primitive.Label>) {
  return (
    <Primitive.Label
      className={cn(
        'px-2.5 py-1.5 text-[11px] font-bold tracking-[0.06em] text-tertiary uppercase',
        className,
      )}
      {...props}
    />
  );
}

export function DropdownSeparator({
  className,
  ...props
}: React.ComponentProps<typeof Primitive.Separator>) {
  return <Primitive.Separator className={cn('my-1 h-px bg-subtle', className)} {...props} />;
}

/** Atalho exibido a direita do item, como na paleta de comandos. */
export function DropdownShortcut({ className, ...props }: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span className={cn('ml-auto font-mono text-[11px] text-tertiary', className)} {...props} />
  );
}
